import * as React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

// style, design
import renderChapter from "./renderChapter";

// store, state
import chapterDefs from "./chapterDefs";
import {
  create,
  destroyPatchForm,
  destroyPostForm,
  constants,
  update,
  detailUrl,
} from "../../../../store/realEstates";
import { useRealEstateForm } from "../../../../store/realEstates";
import ModalChapter from "../../Base/Chapters/ModalChapter";
import {
  setActiveFormInstance,
  updateActiveFormInstance,
} from "../../../../store/base";

export default function AvyTmplRealEstateForm({
  method = "PATCH",
  id,
  isOpen,
  forceAvyId, // newly generated id
  onCheckout,
  successCallback,
  instance,
}) {
  const storeName = constants.STORE_NAME;
  const dispatch = useDispatch();
  const { push } = useHistory();
  const [loading, setLoading] = React.useState(false);
  const formLoaded = Boolean(useRealEstateForm(method, id));

  const checkout = (success) => {
    if (method === "POST") {
      dispatch(destroyPostForm(success));
    } else {
      dispatch(destroyPatchForm(success));
    }

    onCheckout();
  };

  React.useEffect(() => {
    if (formLoaded && instance) {
      dispatch(
        updateActiveFormInstance({
          storeName: constants.STORE_NAME,
          data: instance,
        })
      );
    }
  }, [formLoaded, isOpen]);

  React.useEffect(() => {
    if (!isOpen) {
      dispatch(
        setActiveFormInstance({
          storeName,
          data: {},
        })
      );
    }
  }, [isOpen]);

  const onSuccess = (_, returned) => {
    setLoading(false);
    checkout(true);
    if (method === "POST") {
      push(detailUrl({ id: returned.id }));
    }

    successCallback && successCallback();
  };

  const onSubmit = () => {
    setLoading(true);
    if (method === "POST") {
      dispatch(
        create({
          successCallback: onSuccess,
          errorCallback: () => setLoading(false),
        })
      );
    } else if (method === "PATCH") {
      dispatch(
        update({
          id,
          successCallback: onSuccess,
          errorCallback: () => setLoading(false),
        })
      );
    }
  };

  const onDone = () => {
    checkout(false);
  };

  return (
    <ModalChapter
      loading={!formLoaded || loading}
      storeName={constants.STORE_NAME}
      chapterDefs={chapterDefs}
      onRenderChapter={(key) => renderChapter({ key, method, forceAvyId })}
      submitCallback={onSubmit}
      title={"Uppdatera integrationsinställning"}
      onDone={onDone}
      isOpen={isOpen}
    />
  );
}
